<hlm-popover
  class="w-full"
  align="start"
  [state]="overlayState()"
  (stateChanged)="onStateChanged($event)"
>
  <div
    class="due-date-picker__trigger-wrapper"
    [class.due-date-picker__trigger-wrapper--has-value]="hasValue()"
  >
    <button
      type="button"
      hlmPopoverTrigger
      class="due-date-picker__trigger"
      [class.due-date-picker__trigger--has-value]="hasValue()"
      [attr.aria-label]="ariaLabel()"
      aria-haspopup="dialog"
      [attr.aria-expanded]="isOpen()"
      (keydown)="onTriggerKeydown($event)"
    >
      <span class="due-date-picker__trigger-content">
        @if (hasValue()) {
          <ocp-themed-icon class="due-date-picker__calendar-icon" name="calendar.svg" />
          <span class="due-date-picker__date-label">{{ displayDate() }}</span>
        } @else {
          <span class="due-date-picker__not-set">{{
            placeholder() || ('due-date-picker.not-set' | translate)
          }}</span>
        }
      </span>
      @if (!hasValue()) {
        <ocp-themed-icon
          class="due-date-picker__chevron"
          [name]="chevronIcon()"
          [size]="chevronSize()"
        />
      }
    </button>
    @if (hasValue()) {
      <button
        type="button"
        class="due-date-picker__clear-trigger"
        [attr.aria-label]="'due-date-picker.clear' | translate"
        (click)="onClearFromTrigger($event)"
        (keydown.enter)="onClearFromTrigger($event)"
        (keydown.space)="onClearFromTrigger($event)"
      >
        <ocp-themed-icon class="due-date-picker__cross" name="cross.svg" [size]="9" />
      </button>
    }
  </div>

  <hlm-popover-content *hlmPopoverPortal class="w-fit p-0">
    <div class="due-date-picker__panel">
      <hlm-calendar
        [date]="safeValue()"
        [min]="minDate"
        (dateChange)="onDateSelect($any($event))"
      />
      @if (hasValue()) {
        <button type="button" class="due-date-picker__clear-btn" (click)="onClear()">
          {{ 'due-date-picker.clear' | translate }}
        </button>
      }
    </div>
  </hlm-popover-content>
</hlm-popover>
